import React, { useState, useEffect } from "react";
import ConnectAPI from "../../services/api";
import { authenticationService } from "../../services/context/AuthService";
import Swal from "sweetalert2";
import moment from "moment";
import {IconDownload,Select , Button ,Tooltip, Search,Table,  ConfirmationModal, IconPencil, ContextualMenu, IconPerson, IconUpload, IconTrash, Tabs, IconChevronDoubleLeft  } from "@veneer/core";
import DetNotification from "./notification_wizard";
import { useTranslation } from "react-i18next";
import XLSX from 'xlsx';
import $ from 'jquery';


const Notification = (props) => {
    const [pageSize, setPageSize] = useState(15);
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [inac_tableData, setinac_TableData] = useState([]);
    const [future_table, setfuture_table] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [act_currentPage, setact_CurrentPage] = useState(1);
    const [current_futurepage, setcurrent_futurepage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [notificationdetail, setnotificationdetail] = useState([]);
    const [isnew, setisnew]=useState("NO");
    const selectTab = (event) => (index) => {
        setactiveTabIndex(index);
    };
    useEffect(() => {
      //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
        connectApi
        .get(
          "api/Channels/getnotification",
          "",
          initDataLoad
        )
    },[]);
    const initDataLoad = (status, data) => {
        var active=[];
        var inactive=[];
        var future=[];
        var today=new Date();
        data.forEach(function (task) {

            if (new Date(task.stardate)<today && new Date(task.endDate)>today){
              active.push(task);
            }else if (new Date(task.endDate)<today){
              inactive.push(task);
            }else if (new Date(task.stardate)>today){
              future.push(task);
            }
        });
        setTableData(active);
        setinac_TableData(inactive);
        setfuture_table(future);
        
    }
    function ind_activateLasers(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!="Id"){
        let al = inac_tableData.find(al => al.idnotification == id);
        setnotificationdetail(al);
        setisnew("NO")
        setShowModal(true);
      }
    }
    function activateLasers(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!="Id"){
        let al = tableData.find(al => al.idnotification == id);
        setnotificationdetail(al);
        setisnew("NO")
        setShowModal(true);
      }
    }
    function activate_future(e) {
      var id = $(e.target).closest('tr').children().eq(0).text();
      if (id!="Id" ){
        let al = tableData.find(al => al.idnotification == id);
        setnotificationdetail(al);
        setisnew("NO")
        setShowModal(true);
      }
    }
    const hideSCDetailsModal = () => {
      setShowModal(false);
    }
    const Table_future=()=>{
      const handlePageChange = (page) => setcurrent_futurepage(page);
      return (
        <>
          <Table  onClick={activate_future}
          columns={[
              {
                id:"idnotification",
                label:"Id",
              },
              {
                id:"stardate",
                label:"Start Date",
              
              },
              {
                id:"endDate",
                label:"End Date",
                
              },
              {
                id:"audiencelevel",
                label:"Audience Level"
              },
              {
                id:"audience",
                label:"Audience",
              },
              
              {
                id: 'messageEN',
                label: 'EnMessage'
              },
              {
                id: 'messageES',
                label: 'EsMessage',
              
              },
              {
                id: 'messagePT',
                label: 'PtMessage',
                
              },
              
              
            ]}
          data={future_table}
          showFilters
          columnReorder
          order
          pagination={{
            current_futurepage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: future_table.length,
            }}
            preferences={{
              defaultOrder: "idnotification" ,
              width: [
                {
                  columnId: 'audience', width:40
                },
                {
                  columnId: 'messageEN', width: 100
                },
                {
                  columnId: 'messageES', width: 100
                },
                {
                  columnId: 'messagePT', width: 100
                },
                {
                  columnId: 'stardate', width: 150
                },
                {
                  columnId: 'endDate', width: 150
                },
                {
                  columnId: 'audience', width: 230
                },
              ]
            }}
          />
        </>
      );
    }
    const Table_active=()=>{
      const handlePageChange = (page) => setact_CurrentPage(page);
      return (<>
        <Table  onClick={activateLasers}
         columns={[
            {
              id:"idnotification",
              label:"Id",
            },
            {
              id:"stardate",
              label:"Start Date",
            
            },
            {
              id:"endDate",
              label:"End Date",
              
            },
            {
              id:"audiencelevel",
              label:"Audience Level"
            },
            {
              id:"audience",
              label:"Audience",
            },
            
            {
              id: 'messageEN',
              label: 'EnMessage'
            },
            {
              id: 'messageES',
              label: 'EsMessage',
             
            },
            {
              id: 'messagePT',
              label: 'PtMessage',
              
            },
            
            
          ]}
        data={tableData}
        showFilters
        columnReorder
        order
        pagination={{
            act_currentPage,
            onPageChange: handlePageChange,
            pageSize,
            totalItems: tableData.length,
          }}
          preferences={{
            defaultOrder: "idnotification" ,
            width: [
              {
                columnId: 'messageEN', width: 100
              },
              {
                columnId: 'messageES', width: 100
              },
              {
                columnId: 'messagePT', width: 100
              },
              {
                columnId: 'stardate', width: 150
              },
              {
                columnId: 'endDate', width: 150
              },
              {
                columnId: 'audience', width: 230
              },
            ]
          }}
        />
    </>);
    }
    const Table_inactive=()=>{    
      const handlePageChange = (page) => setCurrentPage(page);
        return (<>
            <Table  onClick={ind_activateLasers}
             columns={[
                
                {
                  id:"idnotification",
                  label:"Id",
                },
                {
                  id:"stardate",
                  label:"Start Date",
                
                },
                {
                  id:"endDate",
                  label:"End Date",
                  
                },
                {
                  id:"audiencelevel",
                  label:"Audience Level"
                },
                {
                  id:"audience",
                  label:"Audience",
                },
                {
                  id: 'messageEN',
                  label: 'EnMessage'
                },
                {
                  id: 'messageES',
                  label: 'EsMessage',
                 
                },
                {
                  id: 'messagePT',
                  label: 'PtMessage',
                  
                }
              ]}
            data={inac_tableData}
            showFilters
            columnReorder
            order
            pagination={{
                currentPage,
                onPageChange: handlePageChange,
                pageSize,
                totalItems: inac_tableData.length,
              }}
              preferences={{
                defaultOrder: "idnotification" ,
                width: [
                  {
                    columnId: 'audience', width:40
                  },
                  {
                    columnId: 'messageEN', width: 100
                  },
                  {
                    columnId: 'messageES', width: 100
                  },
                  {
                    columnId: 'messagePT', width: 100
                  },
                  {
                    columnId: 'stardate', width: 150
                  },
                  {
                    columnId: 'endDate', width: 150
                  },
                  {
                    columnId: 'audience', width: 230
                  },
                ]
              }}
            />
        </>);
    }
    return(<>
      <div>
        <Button onClick={()=>{
          setShowModal(true);
          setnotificationdetail([]);
          setisnew("YES");
        }} >{t("New_Notification")}</Button>
      </div>
        <Tabs
        controlId="default"
        onChangeTab={selectTab()}
        selectedTabId={activeTabIndex}
        tabs={[
            { id: 0, label: t("active"), content: <div style={{ padding: '30px' }}><Table_active/></div> },
            { id: 1, label: t("inactive"), content: <div style={{ padding: '30px' }}><Table_inactive/></div> },
            { id: 2, label: t("future"), content: <div style={{ padding: '30px' }}><Table_future/></div> },
          ]}
      />
      <DetNotification detailnotfication={notificationdetail} onShowModal={showModal} onCloseSCDetailsModal={hideSCDetailsModal} isnew={isnew}/>
    </>);
}

export default Notification;